<template>
  <iColumn class="subscribe-to-newsletter-input" :width="inputContainerWidth" gap="extraSmall">
    <iTextInput
      v-model="emailAddress"
      :placeholder="getOptionValue(Placeholder)"
      :style-overrides="{
        'inputBorderRadius': inputBorderRadius,
        'inputFontColor': inputFontColor,
      }"
      :border-top="inputBorderSides.top"
      :border-bottom="inputBorderSides.bottom"
      :border-left="inputBorderSides.left"
      :border-right="inputBorderSides.right"
      type="email"
      width="fill"
      @enter="subscribeToEmail"
    />
    <iText v-if="errorMessage" class="error-message" font-size="verySmall">
      {{ errorMessage }}
    </iText>
    <iText v-if="successMessage" class="success-message" font-size="verySmall">
      {{ successMessage }}
    </iText>
  </iColumn>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import useDynamicInputStore from "~/stores/dynamic-input-store";
import {
  SubscribeToNewsletterElementMixin,
} from "%/dynamic-component-editor/standard-components/subscribe-to-newsletter/subscribe-to-newsletter-element-mixin";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import BorderSides from "%/dynamic-component-editor/options/border-sides";
import { NEWSLETTER_SUBSCRIPTION_INPUT_KEY, useNewsletterStore } from "~/stores/newsletter-store";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import FontColor from "%/dynamic-component-editor/options/font-color";

export default {
  name: "SubscribeToNewsLetterInput",
  elementPanelSettings: {
    displayName: "Email Text Input",
    displayIcon: "pencil",
    elementType: "element",
    elementGroup: "subscribeToNewsletterElements",
  },
  mixins: [SubscribeToNewsletterElementMixin],
  optionBundles: [
    new LayoutWidthHeightOptions({
      "default.layout-width": "fill",
    }, {
      "layout-height": true,
    }),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
    BorderOptions,
  ],
  options: [
    Placeholder,
    new FontColor({
      "default": {
        "value": "standard",
        "source": "theme.font",
      },
    }),
  ],
  data() {
    return {
      Placeholder,
      LayoutWidth,
      BorderRadius,
      BorderSides,
      FontColor,
    };
  },
  computed: {
    ...mapWritableState(useNewsletterStore, ["emailAddress"]),
    ...mapState(useDynamicInputStore, ["dynamicInputErrors", "dynamicInputSuccesses"]),
    errorMessage() {
      return this.dynamicInputErrors[NEWSLETTER_SUBSCRIPTION_INPUT_KEY];
    },
    successMessage() {
      return this.dynamicInputSuccesses[NEWSLETTER_SUBSCRIPTION_INPUT_KEY];
    },
    inputContainerWidth() {
      return this.getOptionValue(LayoutWidth);
    },
    inputBorderRadius() {
      return this.getOptionValue(BorderRadius);
    },
    inputBorderSides() {
      return this.getOptionValue(BorderSides);
    },
    inputFontColor() {
      return this.getOptionValue(FontColor) || "standard";
    },
  },
  methods: {
    ...mapActions(useNewsletterStore, ["subscribeToEmail"]),
  },
  styleGuide: () => ({
    errorMessageColor: { "color.font": "error" },
    errorMessageSize: { "size.font": "verySmall" },
    successMessageColor: { "color.font": "success" },
    successMessageSize: { "size.font": "verySmall" },
  }),
};
</script>

<style lang="scss" scoped>
.error-message {
  color: v-bind('$getStyles.errorMessageColor') !important;
  font-size: v-bind('$getStyles.errorMessageSize') !important;

  &:hover {
    color: v-bind('$getStyles.errorMessageColor') !important;
    font-size: v-bind('$getStyles.errorMessageSize') !important;
  }
}

.success-message {
  color: v-bind('$getStyles.successMessageColor') !important;
  font-size: v-bind('$getStyles.successMessageSize') !important;

  &:hover {
    color: v-bind('$getStyles.successMessageColor') !important;
    font-size: v-bind('$getStyles.successMessageSize') !important;
  }
}
</style>
